import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_DATA} from '../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../utils/capitalize";
import {getApplicantReport, getLoanApplicationReport} from "../../api/app";
import 'react-quill/dist/quill.snow.css';
import formatNumber from "../../utils/formatNumber";

const Applicant = () => {

    document.title = "Applicant";

    const token = localStorage.getItem('jwtToken');
    const [reset, setReset] = useState(new Date().getTime());

    useEffect(() => {
        getApplicantReport().then((response) => {
            if(!response.error) {
                $('#total-applicant').text(formatNumber(response.payload.total, "digit"));
                $('#total-daily').text(formatNumber(response.payload.daily, "digit"));
                $('#total-monthly').text(formatNumber(response.payload.monthly, "digit"));
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#application').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Applicant Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "applicant",
                        fieldname: "status",
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "user",
                                model: "user",
                                populate: [
                                    {
                                        path: 'location.provincial',
                                        model: 'administrative'
                                    },
                                    {
                                        path: 'location.district',
                                        model: 'district'
                                    },
                                    {
                                        path: 'location.constituency',
                                        model: 'constituency'
                                    }
                                ]
                            },
                            {
                                path: "opportunity",
                                model: "opportunity",
                                populate: [
                                    {
                                        path: "company",
                                        model: "company"
                                    }
                                ]
                            }
                        ],
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.user?.name ? capitalize(data.user.name) : `<span class="tx-danger">No Data</span>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data.opportunity?.position || "No Position");
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data.opportunity?.type || "No Type");
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 4
                }
            ]
        });

        $('#application tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            const { raw } = d;

            const rows = [
                row('Personal Information:', [
                    '<span class="tx-primary">Legal Name: </span>' + capitalize(raw.user.name),
                    '<span class="tx-primary">Gender: </span>' +capitalize(raw.user.gender),
                    '<span class="tx-primary">Mobile Number: </span>' +raw.user.mobile_number,
                    '<span class="tx-primary">NRC Number: </span>' + raw.user.id_number,
                    '<span class="tx-primary">Province: </span>' + raw.user.location.provincial.name,
                    '<span class="tx-primary">District: </span>' + raw.user.location.district.name,
                    '<span class="tx-primary">Constituency: </span>' + raw.user.location.constituency.name
                ].join('<br/>')),
                row('NRC Document:', [
                    'Photo 1: ' + `${raw.user.documents.length ? `<a href=${raw.user.documents[0]?.uri} class="text-secondary" target="_blank"><i class="fa fa-eye"></i> View NRC Front</a>` : "No Document"}` ,
                    'Photo 2: ' + `${raw.user.documents.length ? `<a href='${raw.user.documents[1]?.uri}' class="text-secondary" target="_blank" href=""><i class="fa fa-eye"></i> View NRC Back</a>` : "No Document"}`
                ].join('<br/>')),
                row('Qualification:', [
                    `<a href='${raw.user.qualification?.document?.uri}' class="text-secondary" target="_blank"><i class="fa fa-eye"></i> View Qualification</a>`
                ].join('<br/>')),
                row('Opportunity:', [
                    '<span class="tx-primary">Position:</span> ' +raw.opportunity?.position,
                    '<span class="tx-primary">Description:</span> ' +raw.opportunity?.description,
                    '<span class="tx-primary">Company Name:</span> ' +raw.opportunity?.company?.name,
                    '<span class="tx-primary">Qualification:</span> ' +raw.opportunity?.qualifications,
                    '<span class="tx-primary">Responsibilities:</span> ' +raw.opportunity?.responsibilities,
                ].join('<br/>')),
            ].filter(Boolean).join('');

            return `
                <table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                  ${rows}
                </table>
              `;

            function row(label, html) {
                return `
                  <tr>
                    <td class="tx-semibold">${label}</td>
                    <td>${html}</td>
                  </tr>
                `;
            }

            function actionRow(id) {
                return `
                  <tr>
                    <td class="tx-13 pd-0" colspan="2">
                      <div class="d-flex">Action:
                        <a href="#" id="${id}" class="nav-link pd-t-0 pd-l-5 mark-paid-waste">
                          <i class="fa fa-check"></i> Approve
                        </a>
                        <a href="#" id="${id}" class="nav-link pd-t-0 pd-l-0 delete-waste">
                          <i class="fa fa-trash-alt"></i> Reject
                        </a>
                      </div>
                    </td>
                  </tr>
                `;
            }
        }

        return () => {
            table.destroy();
        }

    }, []);

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Applicants</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Applicants</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-4">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Applicants</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-applicant" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">-</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Applicants Today</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-daily" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="applicant-last-today-info" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Applicants Last 7
                                Days</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-monthly" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="applicant-last-week-info" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Applicant List</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={(e) => {
                                        setReset(new Date().getTime());
                                        e.preventDefault(); $('#application').DataTable().ajax.reload()}
                                    } className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="application" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-25p">Name</th>
                                        <th className="wd-25p">Position</th>
                                        <th className="wd-25p">Type</th>
                                        <th className="wd-25p">Date</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Applicant;
